<template>
	<tbody>
    <tr class="hovereable" v-for="(item, i) in items" :key="`answerTemplate${i}`" @click="applyTemplate(item.text)">
      <td width="70">
        <v-avatar size="45" class="transparent">
          <v-icon large class="k-orange-linear-text" v-if="item.channel === 'facebook'">fas fa-facebook-messenger</v-icon>
          <v-icon large class="k-orange-linear-text" v-else-if="item.channel === 'whatsapp'">fab fa-whatsapp</v-icon>
          <v-icon large class="k-orange-linear-text" v-else-if="item.channel === 'email'">fas fa-envelope</v-icon>
        </v-avatar>
      </td>
      <td class="text-xs-left">
        {{ item.name }}
        <small>
          {{ removeHtmlTags(item.text) }}
        </small>
      </td>
    </tr>
  </tbody>
</template>

<script>
import EventBus from '@/event-bus';
import removeHtmlTags from '@/mixins/removeHtmlTags';

export default {
  props: ['items'],
  mixins: [
    removeHtmlTags,
  ],
  methods: {
    applyTemplate(text) {
      this.$emit('close');
      EventBus.$emit('applyTemplate', text);
    },
  },
};
</script>
<style scoped>
small {
  width: 300px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>


// WEBPACK FOOTER //
// src/components/chat_center/AnswerTemplatesList.vue